/**
 * Shared constants and helpers for Hub user management
 */

import { GROUP_LABELS } from '../../../constants/hub-groups'

export const DEFAULT_INVITE_MESSAGE = 'Welcome! You now have access to VIVA HUB.'

export function formatGroupLabel(groupName) {
  return GROUP_LABELS[groupName] || groupName
}

export const EMPTY_INVITE_DATA = {
  name: '',
  email: '',
  group_ids: [],
  notification_preference: '36h',
  message: DEFAULT_INVITE_MESSAGE,
}

export const EMPTY_USER_FORM = {
  name: '',
  email: '',
  password: '',
  password_confirm: '',
  group_ids: [],
  billing_enabled: true,
  notification_preference: '36h',
  active: true,
  phone: '',
  address: '',
  city: '',
  state: '',
  zip_code: '',
}

export function normalizeGroupIds(item) {
  if (Array.isArray(item?.group_ids) && item.group_ids.length > 0) {
    return item.group_ids.map((id) => Number(id))
  }
  if (item?.group_id) return [Number(item.group_id)]
  return []
}

export function formatUserGroupsLabel(user) {
  const names =
    user.group_names?.length > 0
      ? user.group_names
      : user.group_name
        ? [user.group_name]
        : []
  if (names.length === 0) return 'Unknown'
  return names.map(formatGroupLabel).join(', ')
}

const NOTIFICATION_PREFS = new Set(['none', '24h', '36h', '48h', '72h'])

export function userToFormData(user) {
  return {
    email: user.email,
    name: user.name,
    group_ids: normalizeGroupIds(user),
    active: user.active === 1,
    billing_enabled: user.billing_enabled !== 0,
    notification_preference: NOTIFICATION_PREFS.has(user.notification_preference)
      ? user.notification_preference
      : '36h',
    admin_email_notifications: user.admin_email_notifications !== 0,
    phone: user.phone || '',
    address: user.address || '',
    city: user.city || '',
    state: user.state || '',
    zip_code: user.zip_code || '',
    password: '',
    password_confirm: '',
  }
}
